import { List } from 'immutable';

export default function findTrip(trips, transportType, id) {
  if (!trips) return;

  let tripList;
  const matches = (trip) => trip.get('id') === id;

  switch (transportType) {
    case 'bus': {
      // The after-midnight section's trips live outside `buses.trips`, and one of them can be the
      // chosen outbound: selecting it on a round trip routes to `/:departureId/returns` and the
      // returns container rehydrates it through here. Without this the lookup misses, the chosen
      // departure is undefined, and the arrival-time filter that already ships silently stops
      // applying — the user is offered a return that leaves before the outbound lands, and the
      // rejection arrives at payment.
      //
      // Searched as two lists rather than one concatenation: the trips reducer calls this once per
      // trip while mapping a payload, so concatenating would allocate a fresh list of every trip on
      // every call — N allocations of N items, on an endpoint polled every two seconds.
      const mainTrip = trips.getIn(['buses', 'trips'], List()).find(matches);

      if (mainTrip) return mainTrip;

      return trips.getIn(['buses', 'afterMidnight', 'trips'], List()).find(matches);
    }
    case 'flight':
      tripList = trips.getIn(['flights', 'trips']);
      break;
    case 'mixed':
      tripList = trips.getIn(['mixed', 'trips']);
      break;
    default:
      tripList = List();
  }

  return tripList.find(matches);
}
